<div class="advanced-search">
  <h1 class="typography--title u-m-b-16">Credit Report Summary</h1>
  <div class="advanced-search__form-wrapper">
    <div class="advanced-search__form">
      <form name="schoolSearchForm" aria-label="Search for credit report summary" novalidate [formGroup]="form" (ngSubmit)="onSearch()">
        <div class="advanced-search__field">
          <label for="fromDate" class="advanced-search__label">From Date</label>
          <div class="advanced-search__input">
            <input type="datetime-local" id="fromDate" formControlName="fromDate" />
          </div>
        </div>
        <div class="advanced-search__field">
          <label for="toDate" class="advanced-search__label">To Date</label>
          <div class="advanced-search__input">
            <input type="datetime-local" id="toDate" formControlName="toDate" />
          </div>
        </div>
        <div class="advanced-search__field">
          <label for="lastName" class="advanced-search__label">Last Name</label>
          <div class="advanced-search__input">
            <input type="text" id="lastName" formControlName="lastName" />
          </div>
        </div>
        <div class="advanced-search__field">
          <label for="socialSecurityNumber" class="advanced-search__label">Social Security Number</label>
          <div class="advanced-search__input">
            <input type="text" id="ssn" formControlName="socialSecurityNumber" />
          </div>
        </div>
        <div class="advanced-search__field">
          <label for="creditReportSourceType" class="advanced-search__label">Source</label>
          <div class="advanced-search__input">
            <select id="creditReportSourceType" formControlName="creditReportSourceType">
              <option value="">All</option>
              <option value="OnlineRentals">Online Rental</option>
              <option value="Store">OPUS</option>
            </select>
          </div>
        </div>
        <div class="advanced-search__field">
          <label for="locationId" class="advanced-search__label">Location Number</label>
          <div class="advanced-search__input">
            <input type="number" min="1" max="9999" step="1" id="locationId" formControlName="locationId" />
          </div>
        </div>
        <div class="row align-right">
          <div class="advanced-search__submit btn-group">
            <button type="submit" class="btn btn--elevated btn-group__btn">Search</button>
            <button type="button" class="btn btn--hollow btn--elevated btn-group__btn" (click)="onDownload()">Download</button>
          </div>
        </div>
      </form>
      <div class="full-page-spinner" [class.full-page-spinner--is-active]="(summarySearchState$ | async).loading">
        <div class="full-page-spinner__icon"></div>
      </div>
    </div>
  </div>
</div>
